import { MAX_FILE_SIZE } from '../../constants/wbWidgetConstants';

export const isValidMimeType = (
  file,
  acceptedMimeTypes,
  acceptedFileExtensionsIfUnknown = [],
) => {
  // if file's mime type is known check accepted mime types
  if (file.type !== '') {
    const acceptedMimeTypesLength = acceptedMimeTypes.length;
    const fileType = file.type.toLowerCase();

    let i;
    for (i = 0; i < acceptedMimeTypesLength; i++) {
      const thisAcceptedMimeType = acceptedMimeTypes[i];

      if (fileType === thisAcceptedMimeType) {
        return true;
      }
    }
    // otherwise check the accepted file extensions
  } else {
    return acceptedFileExtensionsIfUnknown.some((ext) =>
      file.name.endsWith(ext),
    );
  }
  return false;
};

export const isValidSize = (file, maxFileSize) => {
  if (typeof maxFileSize !== 'undefined') {
    return file.size <= maxFileSize && file.size > 0;
  } else {
    return file.size <= MAX_FILE_SIZE && file.size > 0;
  }
};

export const isValidName = (fileName) => {
  const dotIndex = fileName.lastIndexOf('.');
  const fname = fileName.substring(0, dotIndex);
  const specialChars = /[`!@#$%^&*()+={};':"\\|,<>/?~]/;
  return !specialChars.test(fname);
};

export const buildFilesErrorMessage = (filesRejected) => {
  const rejectedFilesMessage = filesRejected.reduce((prevMsg, file) => {
    const errorMsg = file.errors.map((e) => e.msg).join(' ');
    return `${prevMsg}Error loading ${file.sourceFile.name}: ${errorMsg}&nbsp;&nbsp;`;
  }, '');

  return rejectedFilesMessage;
};
